import { z } from "zod";

/**
 * ReportSaldoBancarioSchema
 */

export const ReportSaldoBancarioSchema = z.object({
    requiredMimeType: z.string().optional().nullable(),
    idBancoPagamento: z.number().int().optional().nullable(),
    dataDe: z.coerce.date().optional().nullable(),
    dataAte: z.coerce.date().optional().nullable(),
    tipoMovimento: z.array(z.number()).nullable().default(null),
    idUsuario: z.number().int().optional().nullable(),

});

/**
 * ReportSaldoBancarioForm
 */

export type ReportSaldoBancarioForm = z.infer<typeof ReportSaldoBancarioSchema>;


export const defaultReportSaldoBancarioForm: ReportSaldoBancarioForm = {
    idBancoPagamento: null,
    dataDe: null,
    dataAte: null,
    tipoMovimento: null,
    idUsuario: null,
    requiredMimeType: null
};